import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.EXTRAS,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.EVENTS}/${id}`,
    method: "get",
  });
}

function create(data) {
  return request({
    url: ENDPOINT.EXTRAS,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.EXTRAS}/${data.id}`,
    method: "patch",
    data,
  });
}

async function updateMultiple(data) {
  return await request({
    url: `${ENDPOINT.EXTRAS}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.EXTRAS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  updateMultiple,
  remove,
};
